import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Blinds, Home } from '@mui/icons-material';
import { CustomList } from './sidebarStyles';
import { modules, modulesWithLocation } from '../../../constants/modules';
import { getIconModule } from '../../../utils/modules';
import { ListItem } from '../../listItem/listItem';
import {
  currentLocation,
  locationDetails
} from '../../../store/slices/locations/location';
import { selectCurrentUser } from '../../../store/slices/login/login';
import { LocationInfoComponent } from './locationInfo/locationInfo';
import { useGetApplicationsByLocationMutation } from '../../../services/application/applicationService';

export const SidebarList = () => {
  const location = useLocation();
  const currentLocationContext = useSelector(currentLocation);
  const contextUser = useSelector(selectCurrentUser);
  const [allModules, setAllModules] = useState<
    {
      id: number;
      name: string;
      path: string;
      icon: React.JSX.Element;
    }[]
  >([]);
  const locationDetailsContext = useSelector(locationDetails);
  const [getApplicationsByLocation, { isSuccess, data, isLoading }] =
    useGetApplicationsByLocationMutation();

  useEffect(() => {
    if (currentLocationContext && currentLocationContext.locationId) {
      getApplicationsByLocation(currentLocationContext.locationId);
    }
  }, [currentLocationContext]);

  useEffect(() => {
    if (isSuccess && data) {
      const firstItems = modulesWithLocation.slice(0, 2);
      const middleItemsParser = data.map((module) => {
        return {
          id: module.id,
          name: module.name,
          path: `applications/${module.identifier}`,
          icon: getIconModule(`/${module.identifier}/`)
        };
      });
      const lastItems = modulesWithLocation.slice(2, 5);
      setAllModules([...firstItems, ...middleItemsParser, ...lastItems]);
    }
  }, [isSuccess, data]);

  return (
    <CustomList aria-labelledby="nested-list-subheader">
      {!currentLocationContext?.locationId && (
        <ListItem
          key="Locations"
          name="Locations"
          path="/locations"
          id={2}
          selectedId={location.pathname}
        >
          <Blinds />
        </ListItem>
      )}
      {!currentLocationContext?.locationId &&
        modules.map((module) =>
          contextUser.roleInfo?.permissionsByModule.some(
            (moduleContext) => moduleContext.systemModuleName === module.key
          ) ? (
            <ListItem
              key={module.id}
              name={module.name}
              path={module.path}
              id={module.id}
              selectedId={location.pathname}
            >
              {module.icon}
            </ListItem>
          ) : null
        )}

      {!isLoading &&
        currentLocationContext?.locationId &&
        allModules &&
        allModules.map((moduleContext) => (
          <ListItem
            key={`locations-${moduleContext.id}`}
            name={moduleContext.name}
            path={`/locations/${currentLocationContext.locationId}/${moduleContext.path}`}
            id={moduleContext.id}
            selectedId={location.pathname}
          >
            {moduleContext.icon}
          </ListItem>
        ))}

      {currentLocationContext?.locationId && <LocationInfoComponent />}
    </CustomList>
  );
};
